import { render, staticRenderFns } from "./ModalManageTariff.vue?vue&type=template&id=24b88f40"
import script from "./ModalManageTariff.vue?vue&type=script&lang=js"
export * from "./ModalManageTariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports